module.exports = __webpack_public_path__ + "img/10.3da85b50.png";